import { createToolExtension } from '@spotify/plugin-confidence-chat-react';

import { confidenceChatPlugin } from '../plugin';

const mcpTool = (name: string) => (tool: string) =>
  tool === name || tool.endsWith(`__${name}`);

export const CreateFlagPreviewExtension = confidenceChatPlugin.provide(
  createToolExtension({
    id: 'create-flag-preview',
    predicate: mcpTool('create_flag'),
    render: () => null,
    previewFields: [
      { key: 'displayName', label: 'Name' },
      { key: 'description', label: 'Description' },
      { key: 'variants', label: 'Variants' },
      { key: 'defaultVariant', label: 'Default variant' },
    ],
  }),
);

export const UpdateFlagPreviewExtension = confidenceChatPlugin.provide(
  createToolExtension({
    id: 'update-flag-preview',
    predicate: mcpTool('update_flag'),
    render: () => null,
    previewFields: [
      { key: 'displayName', label: 'Name' },
      { key: 'description', label: 'Description' },
      { key: 'variants', label: 'Variants' },
    ],
  }),
);

export const UpdateFlagVariantPreviewExtension = confidenceChatPlugin.provide(
  createToolExtension({
    id: 'update-flag-variant-preview',
    predicate: mcpTool('update_flag_variant'),
    render: () => null,
    previewFields: [
      { key: 'flag', label: 'Flag' },
      { key: 'variant', label: 'Variant' },
      { key: 'displayName', label: 'New name' },
      { key: 'update_mask', label: 'Updated fields' },
    ],
  }),
);

export const UpdateAbtestPreviewExtension = confidenceChatPlugin.provide(
  createToolExtension({
    id: 'update-abtest-preview',
    predicate: mcpTool('update_abtest'),
    render: () => null,
    previewFields: [
      { key: 'name', label: 'A/B test' },
      { key: 'update_mask', label: 'Updated fields' },
    ],
  }),
);

export const CreateAbtestPreviewExtension = confidenceChatPlugin.provide(
  createToolExtension({
    id: 'create-abtest-preview',
    predicate: mcpTool('create_abtest'),
    render: () => null,
    previewFields: [
      { key: 'displayName', label: 'Name' },
      { key: 'abtest.flag', label: 'Flag' },
      { key: 'abtest.treatments', label: 'Treatments' },
      { key: 'surfaces', label: 'Surfaces' },
    ],
  }),
);

export const CreateMetricPreviewExtension = confidenceChatPlugin.provide(
  createToolExtension({
    id: 'create-metric-preview',
    predicate: mcpTool('create_metric'),
    render: () => null,
    previewFields: [
      { key: 'name', label: 'Name' },
      { key: 'description', label: 'Description' },
      { key: 'type', label: 'Type' },
    ],
  }),
);

export const CreateSegmentPreviewExtension = confidenceChatPlugin.provide(
  createToolExtension({
    id: 'create-segment-preview',
    predicate: mcpTool('create_segment'),
    render: () => null,
    previewFields: [
      { key: 'name', label: 'Name' },
      { key: 'description', label: 'Description' },
    ],
  }),
);
